import { motion } from 'framer-motion';
import { Flame, ShoppingBag } from 'lucide-react';
import { BESTSELLERS, CONTACT } from '../data/site';

export default function BestSellers() {
  return (
    <section
      id="mais-vendidos"
      className="bg-[#101013] py-24 sm:py-32"
      data-testid="mais-vendidos-section"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6 }}
          className="font-mono-alt text-xs font-semibold uppercase tracking-[0.3em] text-[#FFB800]"
        >
          Mais vendidos
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-4 font-display text-5xl uppercase leading-none text-white sm:text-6xl"
        >
          Os queridinhos da galera
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="font-serif-accent mt-4 text-xl text-zinc-400"
        >
          Os favoritos que conquistaram a cidade — um bite de cada vez.
        </motion.p>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {BESTSELLERS.map((item, i) => (
            <motion.article
              key={item.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              whileHover={{ y: -8 }}
              className="group overflow-hidden rounded-3xl border border-white/10 bg-[#141418] transition-colors duration-300 hover:border-[#FF5500]/50"
              data-testid={`mais-vendidos-card-${i}`}
            >
              <div className="relative h-60 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.name}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#141418] via-transparent to-transparent" />
                {item.badge && (
                  <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-[#FF5500] px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-[#0D0D0F]">
                    <Flame size={12} strokeWidth={2.5} />
                    {item.badge}
                  </span>
                )}
              </div>
              <div className="p-6">
                <h3 className="font-display text-3xl uppercase text-white">{item.name}</h3>
                <p className="mt-2 text-sm leading-relaxed text-zinc-400">{item.description}</p>
                <div className="mt-5 flex items-center justify-between">
                  <span className="font-display text-3xl text-[#FFB800]">
                    <span className="mr-1 text-base text-zinc-500">R$</span>
                    {item.price}
                  </span>
                  <a
                    href={CONTACT.ifood}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-2 rounded-full bg-[#EA1D2C] px-4 py-2 text-xs font-bold uppercase tracking-wider text-white transition-all duration-300 hover:shadow-[0_0_20px_rgba(234,29,44,0.5)]"
                    data-testid={`mais-vendidos-ifood-btn-${i}`}
                  >
                    <ShoppingBag size={14} /> Pedir
                  </a>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
